let instance = null;
class JsUtil {
    constructor(){
        if(instance) return instance;
        instance = this;
    }
    /*
    * display style 속성 변경
    * [params]
    * className : 클래스명
    * attr : 속성명
    *  */
    display(className, attr){
        document.getElementsByClassName(className)[0].style.display = attr;
    }

    /*
    * 클래스 제거 후 추가
    * [params]
    * id : id명
    * oldClassName : 제거할 클래스
    * newClassName : 추가할 클래스
    *  */
    changeClass(id, oldClassName, newClassName){
        document.getElementById(id).classList.remove(oldClassName);
        document.getElementById(id).classList.add(newClassName);
    }

    /*
    * 값에 콤마 추가 후 return
    * [params]
    * value : 값.
    * [return]
    * 콤마 추가 된 String.
    *  */
    comma(value){
        return (value*1).toLocaleString();
    }

    /*
    * DOM 엘리먼트에 텍스트 기입.
    * [params]
    * id : id명
    * value : 기입할 텍스트
    *  */
    inputText(id, value){
        document.getElementById(id).textContent = value;
    }
}

export default JsUtil;


// WEBPACK FOOTER //
// ./src/js/func/util.js